import {BaseMenuHelpers} from "../base-menu/base-menu-helpers";

export class InlineMenuHelpers extends BaseMenuHelpers {}